import { generatePath } from 'react-router-dom';
import { getParams } from '@hotjar/webapp/domains/heatmaps/hooks/useHeatmapParams';
import { LIST_CONTINUOUS_CAPTURE } from '@hotjar/webapp/constants/routes/heatmaps';

export const getHeatmapRoute = (siteId: string, heatmapParams: Record<string, string>): string => {
  const params = getParams(new URLSearchParams(heatmapParams));
  const urlSearchParams = new URLSearchParams(params);

  return generatePath(`${LIST_CONTINUOUS_CAPTURE.path}?:searchParams`, {
    siteId,
    searchParams: urlSearchParams.toString(),
  });
};
